import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const FileIcon = (p: IconProps) => <Icon {...p}><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2Z" /><path d="M14 2v6h6" /></Icon>
